module.exports = __webpack_public_path__ + "static/media/gnosis-multisig.653d7f4b.svg";